<template>
    <v-list-item
        class="d-flex align-items-center justify-content-center pa-0 comment-item"
        style="min-height: inherit;"
    >
        <v-list-item-avatar class="my-1">
            <v-icon v-if="multiple" color="blue">mdi-comment-text-multiple-outline</v-icon>
            <v-icon v-else color="blue">mdi-comment-text-outline</v-icon>
        </v-list-item-avatar>

        <v-list-item-content style="overflow: visible">
            <v-row>
                <v-col cols="12" :md="editable ? 8 : 9" class="comment-text pl-0">
                    <template v-if="isEditing">
                        <v-textarea
                            v-model="editText"
                            rows="2"
                            auto-grow
                            counter="2250"
                            hide-details="auto"
                            :disabled="isSaving"
                            class="mt-0"
                        ></v-textarea>
                    </template>
                    <template v-else>
                        <div v-if="item.log && (item.log.old || item.log.new)" class="stage-changed">
                            <span v-if="item.log.old" v-text="item.log.old"></span>
                            <v-icon v-if="item.log.old && item.log.new" class="mx-3" color="error">mdi-ray-start-arrow</v-icon>
                            <span v-if="item.log.new" v-text="item.log.new"></span>
                        </div>
                        <span v-if="item.title" v-text="item.title" class="text-break"></span>
                        <span v-if="!!item.log && !!item.log.link" class="ml-1">
                            <a :href="item.log.link" target="_blank">
                                <span v-if="!!item.log.domain" v-text="item.log.domain" class="mr-1"></span>
                                <v-icon color="info" x-small>mdi-open-in-new</v-icon>
                            </a>
                        </span>
                    </template>
                </v-col>
                <v-col cols="12" :md="editable ? 4 : 3">
                    <v-list-item-subtitle class="d-flex flex-column justify-content-start align-items-end pr-2 overflow-visible">
                        <div v-text="item.name" class="comment-author"></div>
                        <div v-text="item.date" class="comment-date text-md-right"></div>
                        <div v-if="editable && !isEditing" class="comment-actions mt-1">
                            <v-btn
                                v-if="item.can_edit"
                                icon
                                x-small
                                color="info"
                                :disabled="isSaving"
                                @click="startEdit"
                            >
                                <v-icon x-small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                                v-if="item.can_delete"
                                icon
                                x-small
                                color="error"
                                :disabled="isSaving"
                                @click="$emit('delete', item)"
                            >
                                <v-icon x-small>mdi-delete</v-icon>
                            </v-btn>
                        </div>
                        <div v-else-if="isEditing" class="comment-actions mt-1">
                            <v-btn
                                icon
                                x-small
                                color="success"
                                :loading="isSaving"
                                @click="saveEdit"
                            >
                                <v-icon x-small>mdi-check</v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                x-small
                                color="grey"
                                :disabled="isSaving"
                                @click="cancelEdit"
                            >
                                <v-icon x-small>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-list-item-subtitle>
                </v-col>
            </v-row>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: "CommentItem",
    props: {
        item: {
            type: Object,
            required: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: false
        },
        isSaving: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            isEditing: false,
            editText: '',
        };
    },
    methods: {
        startEdit() {
            this.editText = this.item.title || '';
            this.isEditing = true;
        },
        cancelEdit() {
            this.isEditing = false;
            this.editText = '';
        },
        saveEdit() {
            const text = (this.editText || '').trim();
            if (!text) {
                return;
            }
            this.$emit('save', { item: this.item, comment: text });
        },
        finishEdit() {
            this.isEditing = false;
            this.editText = '';
        },
    },
}
</script>

<style scoped>
.comment-author,
.comment-date {
    font-size: 12px;
    opacity: 0.5;
    text-align: right;
    margin-top: 3px;
}
.comment-date {
    white-space: nowrap;
    font-size: 10px;
    margin-top: 5px;
}
.stage-changed {
    font-size: 12px;
}
.comment-actions {
    display: flex;
    gap: 2px;
}
</style>
